<template>
    <section class="user-profile-info">
        <v-container>
         <v-form @submit.prevent ref="userNameAndEmail">
         <v-subheader>{{$t("userAccount.profile.updateInfo")}}</v-subheader>
          <div>
                <v-text-field :label="$t('formes.labels.name')" type="text" :rules="[rules.required,rules.counter]" 
                hide-details="auto" :validate-on-blur='true'
                :counter="20" prepend-icon="fa fa-user" class="font-weight-bold"
                required v-model="user.name"
                ></v-text-field>
          </div>
          <div>
                <v-text-field :label="$t('formes.labels.adress')" type="text" :rules="[rules.required,rules.counter]" 
                hide-details="auto" :validate-on-blur='true'
                :counter="20" prepend-icon="fa fa-address-card" class="font-weight-bold"
                required v-model="user.adress" 
                ></v-text-field>
          </div>
          <div class="text-right">
          <v-btn @click="updateNameAndَAdress()" small color="red" dark class="mt-2 mb-2" right ripple>
          <v-icon small left>fa fa-edit</v-icon> {{$t("userAccount.profile.updateInfo")}}</v-btn>
          </div>
         </v-form>
         <v-subheader>{{$t("userAccount.profile.updateEmail")}}</v-subheader>
         <v-form>
          <div>
               <v-text-field :label="$t('formes.labels.email')" type="email" :rules="[rules.required,rules.counter,rules.email]" 
                hide-details="auto" :validate-on-blur='true'
                :counter="20" prepend-icon="fa fa-envelope" class="font-weight-bold"
                required v-model="user.email" 
                ></v-text-field>
          </div>
          <div class="text-right">    
            <v-btn @click="updateEmail()" small color="red" dark class="mt-2 mb-2" right ripple>
          <v-icon small left>fa fa-edit</v-icon> {{$t("userAccount.profile.updateEmail")}}</v-btn>
          </div>
         </v-form>
         <v-form @submit.prevent ref="password">
          <v-subheader>{{$t("userAccount.profile.changePass")}}</v-subheader>
          <div>
               <v-text-field :label="$t('formes.labels.oldPassword')" :type="showPassword ? 'txet' : 'password'"
               :rules="[rules.required,rules.counter]" hide-details="auto" :validate-on-blur='true'
                :counter="20" prepend-inner-icon="fa fa-key"  class="font-weight-bold"
                required v-model="userPass.old" outlined placeholder="your old password her"
                :error-messages='message' :error="message!=''"
                :append-icon="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
                @click:append="showPassword = !showPassword"
                ></v-text-field>
          </div>
          <div>
               <v-text-field :label="$t('formes.labels.newPassword')" :type="showPassword1 ? 'txet' : 'password'" 
               :rules="[rules.required,rules.counter,rules.newPassword]" hide-details="auto"  :validate-on-blur='true'
                :counter="20" prepend-inner-icon="fa fa-key"  class="font-weight-bold"
                required v-model="userPass.new" outlined placeholder="your new password her"
                :append-icon="showPassword1 ? 'fa fa-eye' : 'fa fa-eye-slash'"
                @click:append="showPassword1 = !showPassword1"
                ></v-text-field>
          </div>
          <div>
               <v-text-field :label="$t('formes.labels.confirmPassword')" :type="showPassword2 ? 'txet' : 'password'"  
               :rules="[rules.required,rules.counter,rules.passwordConfirm]" hide-details="auto" :validate-on-blur='true'
                :counter="20" prepend-inner-icon="fa fa-key"  class="font-weight-bold"
                :append-icon="showPassword2 ? 'fa fa-eye' : 'fa fa-eye-slash'"
                @click:append="showPassword2 = !showPassword2"
                required v-model="userPass.confirm" placeholder="confirm your new password " outlined
                ></v-text-field>
          </div>
          <div class="text-right">
          <v-btn :loading="loadingBtn" @click="updateUserPassword()" small color="red" dark class="mt-2 mb-2" right ripple>
          <v-icon small left>fa fa-edit</v-icon>{{$t("userAccount.profile.changePass")}}</v-btn>
          </div>
         </v-form>
        </v-container>
    </section>
</template>

<script>
import firebase from '@/firebase/index'
import {validateRules} from '@/mixins/index'

export default {
    name:'userProfileInfo',
    mixins:[validateRules],
    data() {
        return {
            message:'',
            showPassword1:false,
            showPassword2:false,
            user:null
        }
    },
    methods:{
        updateName(){

        },
        updateEmail(){

        },
       updateNameAndَAdress(){
           if(this.$refs.userNameAndEmail.validate()){
            const user =firebase.auth().currentUser;
            const db=firebase.firestore();
            db.collection('users').doc(user.uid).update({
                name:this.user.name,
                adress:this.user.adress
            })
             .then(()=>{
                 localStorage.setItem('user',JSON.stringify(this.user));
             })
             .catch(error=>{
                 console.log(error);
             })
           }
        },
        updateUserPassword(){
            if(this.$refs.password.validate()){
                this.loadingBtn=true;
            const user = firebase.auth().currentUser;
            const credential = firebase.auth.EmailAuthProvider.credential(
                user.email, 
                this.userPass.old
            );
            user.reauthenticateWithCredential(credential)
            .then(()=>{
                 user.updatePassword(this.userPass.new).then(()=> {
                    this.loadingBtn=false;
                    }).catch(error=> {
                    this.message=error.message;
                    this.loadingBtn=false;
                    console.log(error)
                    })
            })
            .catch(error=>{
              console.log(error)
              this.message=error.message;
              this.loadingBtn=false;
            })
        }
    }
    },
    beforeMount() {
        this.user=this.$store.state.User;
    },
}
</script>